import actions from './actions';

const {
  LIST_EMPLEADO,
  CREATE_EMPLEADO,
  READ_EMPLEADO,
  UPDATE_EMPLEADO,
  DELETE_EMPLEADO,
} = actions;

const initialState = {
  data: [],
  record: {},
};


const empleadoCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_EMPLEADO:      
      return {
        ...state,
        data: data
      }
    case CREATE_EMPLEADO:
      return {
        ...state,
        record: data
      }
    case READ_EMPLEADO:
      return {
        ...state,
        record: data
      }
    case UPDATE_EMPLEADO:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};

export default empleadoCrudReducer;
